document.addEventListener("DOMContentLoaded",function(){

const wrapper=document.querySelector(".buscalo-reviews-wrapper");

if(!wrapper)return;

const cards=wrapper.querySelectorAll(".buscalo-review-card");

if(cards.length<=1)return;

let index=0;

function mostrar(i){

wrapper.scrollTo({

left:cards[i].offsetLeft,

behavior:"smooth"

});

}

setInterval(function(){

index++;

if(index>=cards.length){

index=0;

}

mostrar(index);

},4000);

});